import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaTextArea]'
})

// tslint:disable-next-line: directive-class-suffix
export class TextArea {
  @HostBinding('class.text-area') baseClass = true;
  /**
   * Set to `true` to display the invalid state.
   */
  @HostBinding('class.text-area--invalid') @Input() invalid = false;
  /**
   * Set to `true` to display the valid state.
   */
  @HostBinding('class.text-area--valid') @Input() valid = false;
  /**
   * Set to `true` to display a loading text area.
   */
  @HostBinding('class.skeleton') @Input() skeleton = false;
}
